import { render, staticRenderFns } from "./DirectIncentivesOverviewCard.vue?vue&type=template&id=275622fa"
import script from "./DirectIncentivesOverviewCard.vue?vue&type=script&lang=js"
export * from "./DirectIncentivesOverviewCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports